function handleTabClick(clickedTab) {
  // Find the parent container
  const parentContainer = clickedTab.closest(
    ".c-collapsibleSpecs__content_tabsBody"
  );
  if (!parentContainer) return;

  // Get all tabs and contents within this specific container
  const specs_tabs = parentContainer.querySelectorAll(
    ".c-collapsibleSpecs__tab"
  );
  const specs_tabContents = parentContainer.querySelectorAll(
    ".c-collapsibleSpecs__tabContent"
  );

  // Remove active class from all tabs and contents
  specs_tabs.forEach((t) => t.classList.remove("active"));
  specs_tabContents.forEach((content) => content.classList.remove("active"));

  // Add active class to clicked tab
  clickedTab.classList.add("active");

  // Get target content and activate it
  const targetId = clickedTab.getAttribute("data-target");

  const targetContent = parentContainer.querySelector(`#${targetId}`);
  if (targetContent) {
    targetContent.classList.add("active");
  }
}
